/**
 * The sliver of the product's error-handling lib the vendored components use.
 *
 * The product routes these through Sentry; the admin console has no Sentry, so
 * logging lands on the console and nothing else changes for the caller.
 */
export const ErrorLogger = {
  logError(error: unknown, context?: Record<string, unknown>): void {
    console.error(error, context)
  },
  logMessage(...args: unknown[]): void {
    console.warn(...args)
  },
}
